/**
 * @param {import('axios').AxiosInstance} axiosInstance
 * @param {{ refreshToken: () => Promise<string | undefined>, onRefreshFailure: () => void, shouldIntercept?: (error: import('axios').AxiosError) => boolean }} options
 */
export const createTokenRefreshInterceptor = (axiosInstance, options) => {
  let refreshPromise = null

  const { refreshToken, onRefreshFailure, shouldIntercept = (error) => error.response?.status === 401 } = options

  axiosInstance.interceptors.response.use(undefined, async (error) => {
    const originalConfig = error.config

    if (!originalConfig || originalConfig._retry || !shouldIntercept(error)) {
      return Promise.reject(error)
    }

    originalConfig._retry = true

    if (!refreshPromise) {
      refreshPromise = refreshToken().finally(() => {
        refreshPromise = null
      })
    }

    try {
      const newToken = await refreshPromise

      if (!newToken) {
        onRefreshFailure()
        return Promise.reject(error)
      }

      originalConfig.headers['Authorization'] = `Bearer ${newToken}`
      return axiosInstance(originalConfig)
    } catch {
      onRefreshFailure()
      return Promise.reject(error)
    }
  })
}
